const LocalStorageService = (() => {
    let _service;
    const _getService = () => {
        if (!_service) {
            _service = this;
            return _service;
        }
        return _service;
    };

    const _setToken = (tokenObj) => {
        localStorage.setItem("jwtToken", tokenObj.token);
        localStorage.setItem("refreshToken", tokenObj.refreshToken);
    };

    const _getAccessToken = () => localStorage.getItem("jwtToken");

    const _getRefreshToken = () =>  localStorage.getItem("refreshToken");

    const _clearToken = () => {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("refreshToken");
    };

    return {
        getService: _getService,
        setToken: _setToken,
        getAccessToken: _getAccessToken,
        getRefreshToken: _getRefreshToken,
        clearToken: _clearToken
    };
})();

export default LocalStorageService;



// WEBPACK FOOTER //
// ./src/utils/LocalStorageService.js